export default __webpack_public_path__ + "static/media/FB.6b3acce1.png";